import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import UserNewsNotificationsListDisplay from './UserNewsNotificationsListDisplay';
import '../../css/blink.css';

class UserNotificationsWrap extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>News Keyword Search Notifications</title> 
          <link rel="canonical" href="https://www.vizfm.com/notifications" />
          <meta name="description" content="All Notifications for Investors and Traders" />
        </Helmet>
        <Container fluid className="p-2">
          <Row>
            <Col xs={9} sm={9} md={10} lg={11} xl={11}><h5>News Keyword Search Notifications</h5></Col>
          </Row>
          <Row>
            <Col><UserNewsNotificationsListDisplay /></Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default UserNotificationsWrap;
